// 보기 설정 쿠키를 브라우저에서 읽는다 — 서버 그리기(document 없음)에선 undefined.
export const cookieOf = (name: string): string | undefined => {
  if (typeof document === "undefined") return undefined;
  const hit = document.cookie.split("; ").find((part) => part.startsWith(`${name}=`));
  return hit ? decodeURIComponent(hit.slice(name.length + 1)) : undefined;
};
